import { Type } from 'class-transformer';
import { Task } from './task';
import { InteractionClassification } from './interaction_classification';

export class Classification extends InteractionClassification {
  @Type(() => Task)
  tasks: Task[];
}
